import ListingsRoutingResolver from './ListingRoutingResolver';

class OcrListingLegacyResolver extends ListingsRoutingResolver {
    constructor() {
        super();
        this.key = 'ocr';
    }
}

export default OcrListingLegacyResolver;
